<template>
    <div id="home" data-type="home">

    </div>
</template>
